import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ContactService } from '../../services/contact.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-be-a-partner',
  standalone: false,
  templateUrl: './be-a-partner.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './be-a-partner.component.scss',
})
export class BeAPartnerComponent {
  contactForm: FormGroup;
    captchaQuestion: string = '';
  captchaAnswer: number = 0;
  emailSent: boolean = false;

    constructor(private fb: FormBuilder, private contactService: ContactService, private snackBar: MatSnackBar, private router: Router) {
    this.contactForm = this.fb.group(
      {
        name: ['', [Validators.required]],
        title: ['', [Validators.required]],
        email: ['', [Validators.required, Validators.email]],
        phone: ['', []],
        message: ['', [Validators.required]],
        captcha: ['', [Validators.required]],
      },
      { validators: this.emailOrPhoneRequiredValidator }
    );
  }


  ngOnInit(): void {
    this.generateCaptcha();
  }

  generateCaptcha(): void {
    const num1 = Math.floor(Math.random() * 10) + 1; // Random number between 1 and 10
    const num2 = Math.floor(Math.random() * 10) + 1; // Random number between 1 and 10
    this.captchaQuestion = `Jaki jest wynik działania: ${num1} + ${num2}?`;
    this.captchaAnswer = num1 + num2;
  }

  emailOrPhoneRequiredValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const email = group.get('email')?.value;
    const phone = group.get('phone')?.value;

    if (!email && !phone) {
      return { emailOrPhoneRequired: true };
    }
    return null;
  }

  goToContactForm(): void {
    this.router.navigate(['/kontakt']);
  }


  onSubmit(): void {
    if (this.contactForm.valid) {
      const captchaInput = this.contactForm.get('captcha')?.value;
      if (parseInt(captchaInput, 10) !== this.captchaAnswer) {
        alert('Kod zabezpieczeństwa jest nieprawidłowy. Spróbuj ponownie.');
        this.generateCaptcha(); // Generate a new CAPTCHA
        this.contactForm.get('captcha')?.setErrors({ wrongCaptcha: true });
        return;
      }

      this.contactService.sendPartnerContactForm(this.contactForm.value).subscribe({
        next: () => {
          this.snackBar.open('Formularz kontaktowy został wysłany pomyślnie!', 'Zamknij', {
            duration: 29000,
            panelClass: ['success-snackbar'],
            horizontalPosition: 'center', // Center horizontally
            verticalPosition: 'bottom',
          });

          this.emailSent = true;
          this.contactForm.reset();
          this.generateCaptcha(); // Reset CAPTCHA after successful submission
        },
        error: (error) => {
          this.snackBar.open('Wystąpił błąd podczas wysyłania formularza. Spróbuj ponownie później.', 'Zamknij', {
            duration: 29000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
          });
        }
      });
    } else {
      this.snackBar.open('Formularz jest nieprawidłowy. Sprawdź wprowadzone dane.', 'Zamknij', {
        duration: 29000,
        panelClass: ['error-snackbar'],
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    }
  }

  sendNewEmail(): void {
    this.emailSent = false;
    this.contactForm.reset();
    this.generateCaptcha();
  }

  scrollToContactForm(): void {
    const element = document.querySelector('[name="contact-form"]');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  
}
